import { Map } from 'immutable';

import {
  CREATE_RELAY_CONTROLLER,
  DELETE_RELAY_CONTROLLER,
  EDIT_RELAY_CONTROLLER,
  RECEIVE_SMARTLINK_UNITS,
  REQUEST_SMARTLINK_UNIT,
  UPDATE_SMARTLINK_UNIT_CURRENT_UPGRADE,
} from '@sophocles/entities/SmartlinkUnit/smartlinkUnitActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SMARTLINK_UNITS:
      return state.mergeDeep(action.smartlinkUnits);
    case DELETE_RELAY_CONTROLLER:
      return state.delete(action.relayController.toString());
    case EDIT_RELAY_CONTROLLER:
    case CREATE_RELAY_CONTROLLER:
    case REQUEST_SMARTLINK_UNIT:
    default:
      return state;
  }
}

export function smartlinkUnitReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_SMARTLINK_UNITS:
    case DELETE_RELAY_CONTROLLER:
    case EDIT_RELAY_CONTROLLER:
    case CREATE_RELAY_CONTROLLER:
    case REQUEST_SMARTLINK_UNIT:
      return state.merge(getState(state, action));
    case UPDATE_SMARTLINK_UNIT_CURRENT_UPGRADE: {
      // Surgical patch from the firmware-portal progress socket event.
      // Only touches current_upgrade on the targeted unit; never
      // disturbs relays, radio, or other nested state.
      const key = String(action.relayControllerId);
      const existing = state.get(key);
      if (existing == null) return state;
      return state.set(key, existing.set('current_upgrade', action.currentUpgrade));
    }
    default:
      return state;
  }
}
